import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  yLinear,
  backgroundColor,
  tooltipScatter,
  discreteLegend,
  color,
  initPivot,
  datasetPivot,
  pivotDiscreteLegend,
  pivotIndicators,
  pivotAdapter,
  pivotIndicatorsAsRow,
  pivotGridStyle,
  pivotColumnDimensions,
  pivotRowDimensions,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
  pointStyle,
  verticalCrosshairLine,
  xLinear,
  horizontalCrosshairLine,
  pointStateHover,
  initScatter,
  scatterAnimation,
  progressive,
  datasetScatter,
  linearColor,
  colorAdapter,
  colorPointStyleFill,
  colorLegend,
  pivotColorLegend,
  labelScatter,
  scatterSize,
  linearRegressionLine,
  lowessRegressionLine,
  polynomialRegressionLine,
  logisticRegressionLine,
  pivotAxisStyle,
  pivotTitle,
  dimensionLinkage,
  brush,
  fontFamilyTheme,
} from '../pipes'

const scatter: VChartSpecPipeline = [
  fontFamilyTheme,
  initScatter,
  scatterAnimation,
  colorAdapter(color, linearColor),
  backgroundColor,
  datasetScatter,
  animationMorph,
  progressive,
  xLinear,
  yLinear,
  brush,
  scatterSize,
  labelScatter,
  tooltipScatter,
  colorAdapter(discreteLegend, colorLegend),
  verticalCrosshairLine,
  horizontalCrosshairLine,
  colorPointStyleFill(pointStyle),
  pointStateHover,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
  linearRegressionLine,
  lowessRegressionLine,
  polynomialRegressionLine,
  logisticRegressionLine,
]

const pivotScatter: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsRow,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initScatter,
    scatterAnimation,
    colorAdapter(color, linearColor),
    backgroundColor,
    datasetScatter,
    animationMorph,
    progressive,
    xLinear,
    pivotAxisStyle(yLinear),
    brush,
    scatterSize,
    labelScatter,
    tooltipScatter,
    verticalCrosshairLine,
    horizontalCrosshairLine,
    colorPointStyleFill(pointStyle),
    pointStateHover,
    annotationPoint,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationArea,
    linearRegressionLine,
    lowessRegressionLine,
    polynomialRegressionLine,
    logisticRegressionLine,
  ]),
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
  dimensionLinkage,
]

export const scatterSpecPipeline = [pivotAdapter(scatter, pivotScatter)]
